import { render } from "./FormCoverImage.vue?vue&type=template&id=248cc57a&scoped=true"
import script from "./FormCoverImage.vue?vue&type=script&lang=js"
export * from "./FormCoverImage.vue?vue&type=script&lang=js"

import "./FormCoverImage.vue?vue&type=style&index=0&id=248cc57a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-248cc57a"

export default script